import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { CardElement } from "@stripe/react-stripe-js";
import { useState } from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export default function Checkout({
  selectedProduct,
  name,
  setName,
  email,
  setEmail,
  handleSubscribe,
  loading,
  goBack,
}) {
  const [touched, setTouched] = useState(false);

  const isEmailValid = EMAIL_REGEX.test(email);
  const emailError = touched && (!email || !isEmailValid);

  return (
    <Box sx={{ mt: 4, display: "grid", gap: 3 }}>
      {/* Back Button */}
      <Button
        variant="outlined"
        color="secondary"
        onClick={goBack}
        sx={{ borderRadius: "30px", justifySelf: "start" }}
      >
        ← Back to Plans
      </Button>

      {/* Plan Summary */}
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 3,
          p: 3,
          border: "2px solid #1976d2",
          background: "linear-gradient(135deg, #e3f2fd,#fff)",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Selected Plan
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: "bold", my: 1 }}>
          {selectedProduct.name}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 500 }}>
          ${(selectedProduct.unit_amount / 100).toFixed(2)} /{" "}
          {selectedProduct.interval}
          {/* ${(selectedProduct.default_price?.unit_amount / 100).toFixed(2)} /{" "}
          {selectedProduct.default_price?.recurring?.interval} */}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {selectedProduct.description || "Cancel anytime."}
        </Typography>
      </Card>

      {/* User Info */}
      <TextField
        label="Full Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        error={!name}
        helperText={!name ? "Name is required" : ""}
      />
      <TextField
        label="Email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onBlur={() => setTouched(true)}
        required
        error={emailError}
        helperText={
          emailError
            ? !email
              ? "Email is required"
              : "Enter a valid email address"
            : ""
        }
      />

      {/* Card Element */}
      <Box sx={{ p: 2, border: "1px solid", borderRadius: 2 }}>
        <CardElement options={{ hidePostalCode: false }} />
      </Box>

      <Button
        variant="contained"
        size="large"
        onClick={handleSubscribe}
        disabled={loading || !name || emailError}
        sx={{ borderRadius: "30px", py: 1.5, fontWeight: 600 }}
      >
        {loading ? "Processing…" : `Subscribe`}
      </Button>
    </Box>
  );
}
